
import { Link } from 'react-router-dom';
import Header from '../components/feature/Header';
import Footer from '../components/feature/Footer';
import Button from '../components/base/Button';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="flex-1 flex items-center justify-center py-20">
        <div className="text-center">
          <div className="mb-8">
            <div className="w-24 h-24 bg-[#e18033]/20 rounded-full flex items-center justify-center mx-auto mb-6">
              <div className="w-12 h-12 flex items-center justify-center">
                <i className="ri-error-warning-line text-[#e18033] text-4xl"></i>
              </div>
            </div>
            <h1 className="text-4xl md:text-6xl font-bold text-[#212026] mb-4">404</h1>
            <h2 className="text-2xl md:text-3xl font-semibold text-[#212026] mb-4">Page Not Found</h2>
            <p className="text-lg text-[#889d8f] max-w-md mx-auto mb-8">
              The page you're looking for doesn't exist or has been moved.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/">
              <Button variant="primary" size="lg">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-home-line"></i>
                </div>
                Go Home
              </Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline" size="lg">
                <div className="w-5 h-5 flex items-center justify-center mr-2">
                  <i className="ri-phone-line"></i>
                </div>
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
